import template from './approve_documents.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class AdminApproveDocumentsViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_documents = ko.observableArray([]);
		this.access_roles = ko.observableArray([]);
		this.document_types = ko.observableArray([]);
		this.query_table = ko.observable();
		this.loader = ko.observable(false);
	}

	async edit_document(data)
	{
		await Grape.dialog.open('EditDocument', { document_data: data });
		this.page.updateData();
	}

	async reject_document(data)
	{
		let value = ko.toJS(data);
		await Grape.dialog.open('EmployeeDocumentReject', { employee_document_id: value.employee_document_id });
		this.page.updateData();
	}

	async approve_document(v,)
	{
		let response = await Grape.alerts.confirm({ type: 'info', title: tr('Confirm'), message: tr('Are you sure you want to approve this document?') });
		if (response)
		{
			try {
				let data = ko.toJS(v);
				let res = await Grape.fetches.postJSON('/admin/approve_document', data);
				if (res.status === 'OK')
				{
					Grape.alerts.alert({ type: 'success', title: tr('Success', 'Success'), message: tr('Successfully approved document.') });
					this.page.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while approving the document..') });
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while approving the document..') });
			}
		}
	}

	async download_document(data)
	{
		window.open(data, '_blank');
	}

	documentsRenderedHandler()
	{
		window.Grape.update_visible_roles();
		Utils.refresh_data_visible_roles();
	}
}

class AdminApproveDocumentsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminApproveDocumentsViewModel(this);
	}

	async init()
	{
		document.title = tr('Approve Documents');
		window.current_page_title(tr('Approve Uploaded Documents'));
	}

	async updateData()
	{
		Navbar.updateSystemCount();
		Utils.refresh_data_visible_roles();
		this.viewModel.loader(true);

		try {
			let res = await Grape.fetches.getJSON('api/record',{
				table: 'v_grouped_employee_documents',
				schema: 'savanna',
				offset: 0,
			});

			if (res.status == 'OK')
				this.viewModel.employee_documents(res.records);
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', title: tr('Error'), message: tr('An error occurred while loading the documents..') });
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while loading the documents..') });
		}

		this.viewModel.loader(false);
	}
}

export default {
	route: '[/]admin/approve_documents',
	page_class: AdminApproveDocumentsPage,
	template: template,
	template_filename: 'translation/approve_documents'
};
